import { Accordion, Box } from '@mui/material'
import styled from '@emotion/styled/macro'
import theme from 'theme'

export const AddProductFormWrapper = styled(Box)`
  padding: 8px 40px;
  display: flex;
  flex-direction: column;
  gap: 40px;
  flex: 1;
  overflow-y: auto;

  .add-product-header {
    color: ${theme.colors.foreground};
    font-family: Quicksand, sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
    letter-spacing: 0.1px;
  }

  .license-details-wrapper {
    display: flex;
    flex-direction: column;
    gap: 28px;

    .dates-group {
      display: flex;
      align-items: center;
      gap: 12px;
      width: 100%;
    }
  }

  .inputs-group {
    display: flex;
    flex-direction: column;
    gap: 24px;

    .group-title {
      display: flex;
      align-items: center;
      gap: 8px;

      .group-title-content {
        display: flex;
        align-items: center;
        gap: 8px;
        cursor: pointer;
      }

      .title {
        color: ${theme.colors.foreground};
        font-family: Quicksand, sans-serif;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 22px;
      }

      .text {
        color: ${theme.colors.cardDateText};
        font-family: Quicksand, sans-serif;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 22px;
      }
    }
  }

  .contract-groups-year-selector-wrapper {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    align-items: center;

    .year-selector-text {
      color: ${theme.colors.cta};
      text-align: right;
      font-family: Quicksand, sans-serif;
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: 22px;
      cursor: pointer;
      text-decoration: none;

      &:hover {
        opacity: 0.8;
      }
    }
  }

  .note-wrapper {
    display: flex;
    flex-direction: column;
    gap: 24px;

    .placement-note-title {
      color: ${theme.colors.foreground};
      font-family: Quicksand, sans-serif;
      font-size: 16px;
      font-style: normal;
      font-weight: 500;
      line-height: 24px;
      letter-spacing: 0.1px;
    }
  }

  .expense-calculation {
    .cost-distribution-title {
      color: ${theme.colors.foreground};
      font-family: Quicksand, sans-serif;
      font-size: 16px;
      font-style: normal;
      font-weight: 500;
      line-height: 24px;
      letter-spacing: 0.1px;
      margin-bottom: 24px;
    }

    .cost-distribution-form-control {
      .MuiFormGroup-root {
        .MuiFormControlLabel-root {
          .MuiRadio-root {
            svg {
              width: 16px;
              height: 16px;

              path {
                fill: ${theme.colors.foreground};
              }
            }
          }

          .MuiTypography-root.MuiFormControlLabel-label {
            color: ${theme.colors.textSecondary};
            font-family: Quicksand, sans-serif;
            font-size: 14px;
            font-style: normal;
            font-weight: 500;
            line-height: 22px;
          }
        }
      }
    }

    .expense-calculation-field-wrapper {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 16px;
      gap: 8px;

      .expense-calculation-field-item {
        width: 100%;

        .expense-calculation-left {
          width: 100%;
          border-radius: 12px;
          background: ${theme.colors.btnSecondaryHoverBg};
          display: flex;
          height: 48px;
          padding: 12px 16px;
          align-items: center;
          gap: 12px;
          flex: 1 0 0;
          min-width: 292px;

          .current-area {
            width: fit-content;
            border-radius: 8px;
            background: ${theme.colors.legacyPrimaryLight3};
            display: flex;
            height: 24px;
            padding: 2px 8px;
            justify-content: center;
            align-items: center;
            gap: 3px;
            color: ${theme.colors.cta};
            text-align: center;
            font-family: Quicksand, sans-serif;
            font-size: 12px;
            font-style: normal;
            font-weight: 500;
            line-height: 16px;
            letter-spacing: 0.5px;
            white-space: nowrap;
          }
        }
      }
    }
  }
`

export const SumNotMatchedWrapper = styled(Box)`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 16px;
  padding: 16px;
  background-color: ${theme.colors.errorLight};
  border-radius: 4px;
`

export const LicenseDetailsAccordion = styled(Accordion)`
  .MuiAccordionSummary-root {
    .MuiAccordionSummary-expandIconWrapper {
      svg {
        path {
          fill: ${theme.colors.menuItemText};
        }
      }
    }
  }

  .MuiCollapse-root {
    .MuiAccordionDetails-root {
      padding-top: 28px;
      display: flex;
      flex-direction: column;
      gap: 40px;

      .dates-group {
        display: flex;
        align-items: center;
        gap: 12px;
        width: 100%;
      }
    }
  }
`
